/**
 * Created by jonas on 2021-02-02.
 */
import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {
    BS2GameData,
    BS2InitData,
    isBS2GameData,
    PossibleWinData,
    PossibleWinLineData,
    SpinMode,
    SymbolValues,
    WinData,
    WinLineData,
    XSplitData,
    XSplitDirection,
} from "./BS2Data";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {StateMatrix, StateMatrixCoordinate} from "../utils/StateMatrix";
import {BS2Symbol, BS2SymbolStates} from "../reels/BS2Symbol";
import {BS2} from "../BS2";
import {BS2Statics} from "../config/BS2Statics";
import {BS2GameMode} from "./BS2GameMode";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {ReelUtils} from "../utils/ReelUtils";

export class BS2Model extends GameModel<BS2InitData, BS2GameData> {

    public isRestore: boolean = false;
    public visibleReelMatrix: StateMatrix<string>;
    public evaluatedArea: StateMatrix<string>;
    public clientReels: StateMatrix<string>;
    public winData: WinData;
    public isRestoreFeatureBet: boolean;
    public buyFeatureName: string;
    public symbolValues?: SymbolValues;
    public hasWonFsClient: boolean = false;
    public winCapReached: boolean = false;
    public nearWinReels: boolean[] = [false, false, false, false, false];
    public possibleWinData: PossibleWinData;
    public featureBetCollectPerReel: (number | undefined)[];
    public collectedSymbols: number;
    public currentLevel: number;
    public nextLevel: number;
    public xSplitData: XSplitData[][] | undefined;
    public reelsAfterCollapse: string[][];
    public initReels: string[][];


    constructor(api: ApiPlugin, triggerEvents: boolean = true) {
        super(api, triggerEvents);

        api.events.once("featureName", (data: string) => {
            this.buyFeatureName = data;
        });
        BS2.apiPlugin.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < BS2.model.initData.featureBuyTimesBetValue.length; index++) {
                if (BS2.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });

        BS2.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < BS2.model.initData.featureBuyTimesBetValue.length; index++) {
                if (BS2.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
    }

    public handleScatterOnRestore(originalReels: string[][], nextLevel: number): string[][] {
        const returnReels: string[][] = JSON.parse(JSON.stringify(originalReels));
        for (let reelIdx: number = 0; reelIdx < BS2Statics.NR_OF_REELS; reelIdx++) {
            const reel = returnReels[reelIdx];
            for (let symIdx: number = 1; symIdx < reel.length - 1; symIdx++) {
                if (reel[symIdx] === BS2Statics.SYMBOLS.S) {
                    const newArr = [getBufftSym()];
                    for (let k: number = 0; k < symIdx; k++) {
                        newArr.push(reel[k]);
                    }
                    for (let k: number = 0; k < newArr.length; k++) {
                        reel[k] = newArr[k];
                    }
                    break;
                }
            }
        }
        return returnReels;

        function getBufftSym(): string {
            switch (nextLevel) {
                case 1:
                    return "H5";
                case 2:
                    return "H4";
                case 3:
                    return "H3";
                case 4:
                    return "H2";
                case 5:
                    return "H1";
            }
            return "M1";
        }
    }

    public onInit(data: BS2InitData): void {
        super.onInit(data);
        if (data.wasFeatureBuy && data.mode === BS2GameMode.NORMAL && data.nextMode !== BS2GameMode.NORMAL && data.nextLevel && (data.nextLevel - data.currentLevel > 1)) {
            this.changeXSymToEM(data.reels);
            this.changeXSymToEM(data.reelsAfterCollapse);
        }
        this.collectedSymbols = data.collectedSymbols;
        this.currentLevel = data.currentLevel;
        this.symbolValues = data.symbolValues;
        this.isRestore = data.isRestoreState;
        this.nextLevel = data.nextLevel;
        this.reelsAfterCollapse = data.reelsAfterCollapse;
        if (this.isRestore && data.wasFeatureBuy) {
            this.isRestoreFeatureBet = true;

            if (data.mode == BS2GameMode.NORMAL) {
                if (data.reels[0].includes("EM")) {
                    for (let i: number = 0; i < data.reels.length; i++) {
                        for (let j: number = 0; j < data.reels[i].length; j++) {
                            if (data.reels[i][j][0] === "M") {
                                data.reels[i][j] = data.reels[i][j].replace("M", "H");
                            }
                        }
                    }
                }
            }
        }
        this.initReels = this.handleScatterOnRestore(data.reels, data.nextLevel);
    }

    public onGame(data: BS2GameData): void {
        super.onGame(data);
        if (data.wasFeatureBuy && data.mode === BS2GameMode.NORMAL && data.nextMode !== BS2GameMode.NORMAL && data.nextLevel && (data.nextLevel - data.currentLevel > 1)) {
            this.changeXSymToEM(data.reels);
            this.changeXSymToEM(data.reelsAfterCollapse);
            this.changeXSymToEM(data.evaluatedArea);
            this.changeMidAndHighSym(data.reels);
            this.changeMidAndHighSym(data.reelsAfterCollapse);
            this.changeMidAndHighSym(data.evaluatedArea);
        }

        this.nextLevel = data.nextLevel;
        this.collectedSymbols = data.collectedSymbols;
        this.currentLevel = data.currentLevel;
        this.clientReels = new StateMatrix<string>(data.reels);
        this.isRestore = false;
        this.evaluatedArea = new StateMatrix<string>(data.evaluatedArea);
        this.visibleReelMatrix = new StateMatrix<string>();
        this.visibleReelMatrix.initWithMatrixAndMatchDimensionsFromMatrix(data.reels, data.evaluatedArea, {
            column: 0,
            row: 1
        });
        this.winData = this.createWinData(data, this.visibleReelMatrix, this.evaluatedArea);
        this.possibleWinData = this.calculatePossibleWinData2(data, this.winData, this.visibleReelMatrix)
        this.featureBetCollectPerReel = [undefined, undefined, undefined, undefined, undefined];
        if (data.wasFeatureBuy && data.mode == BS2GameMode.NORMAL) {
            this.featureBetCollectPerReel = [0, 0, 0, 0, 0];
            let levelIndex: number = 0;
            const symbols: string[] = BS2Statics.MID_SYMBOLS.concat();
            symbols.reverse();
            for (let symbol of symbols) {
                const symCoords: StateMatrixCoordinate[] = this.evaluatedArea.getAllCoordinatesForValue(symbol);
                if (symCoords.length > 0) {
                    this.featureBetCollectPerReel[symCoords[0].column] = this.initData.gameLevels[levelIndex];
                    levelIndex++;
                }
            }
        }
        if (data.isRandomLevel === true && data.mode == BS2GameMode.NORMAL) {
            this.nearWinReels = [false, true, true, true, true];

        } else {
            this.nearWinReels = [false, false, false, false, false];
        }
        this.reelsAfterCollapse = data.reelsAfterCollapse;
        this.createXSplitData(data);
        this.resetNumberOfSplitsOnItFlagInSym();
    }
    private resetNumberOfSplitsOnItFlagInSym():void{
        for(let reelIdx:number=0;reelIdx<BS2Statics.NR_OF_REELS;reelIdx++){
            for(let symIdx:number=0;symIdx<BS2Statics.BOT_STICKY_WILD_IDX_VIS_AREA;symIdx++){
                (<BS2Symbol>BS2.reelView.reels[reelIdx].model.getVisibleSymbolAt(symIdx).positionable).numberOfSplitsOnIt = 0;
            }
        }
    }

    public createWinData(data: BS2GameData, visibleReelMatrix: StateMatrix<string>, evaluatedArea: StateMatrix<string>): WinData {
        const winLines: WinLineData[] = [];
        const winMatrix: StateMatrix<BS2SymbolStates> = new StateMatrix<BS2SymbolStates>();
        winMatrix.initWithValueAndMatchDimensionsFromMatrix(BS2SymbolStates.NO_WIN, visibleReelMatrix.matrix);

        const winRatio: number = data.thisSpinWinning / data.playedBetValue;
        const accumulatedWinRatio: number = data.accumulatedRoundWin / data.playedBetValue;

        let winWays: number = 0;
        if (isBS2GameData(data)) {
            for (let win of data.betWayWins) {
                winWays += win.numberOfCombinations;
                let matchingSymbols = [win.symbol, "W"];

                const lineMatrix: StateMatrix<boolean> = new StateMatrix();
                lineMatrix.initWithValueAndMatchDimensionsFromMatrix(false, evaluatedArea.matrix);
                const lineData: WinLineData = {
                    betWayWin: win,
                    coordinates: [],
                    matrix: lineMatrix
                }

                lineData.coordinates = evaluatedArea.getAllCoordinatesWhere((value: string, column: number, row: number) => {
                    return matchingSymbols.indexOf(value) >= 0 && column < win.length;
                });


                winMatrix.setValueForCoordinates(lineData.coordinates, BS2SymbolStates.WIN_HIGHLIGHT);
                lineMatrix.setValueForCoordinates(lineData.coordinates, true);
                winLines.push(lineData);
            }
        }


        return {
            lines: winLines,
            matrix: winMatrix,
            winWays: winWays,
            winRatio: winRatio,
            accumulatedWinRatio: accumulatedWinRatio,
            accumulatedWin: data.accumulatedRoundWin
        }
    }

    public isNearWinAllowed(): boolean {
        return !this.hasWonFsClient && !this.data.wasFeatureBuy;
    }

    public isNextFreeSpin() {
        return this.data.nextMode == BS2GameMode.FREESPIN || this.data.nextMode == BS2GameMode.AVALANCHE_FREESPIN;
    }

    public isNextNormal() {
        return this.data.nextMode == BS2GameMode.NORMAL;
    }

    public isFreeSpin() {
        return this.data.mode == BS2GameMode.FREESPIN || this.data.mode == BS2GameMode.AVALANCHE_FREESPIN;
    }

    public isSuperFreespin() {
        return this.data.mode == BS2GameMode.FREESPIN_SUPER || this.data.mode == BS2GameMode.AVALANCHE_FREESPIN_SUPER;
    }

    public isNextSuperFreespin() {
        return this.data.nextMode == BS2GameMode.FREESPIN_SUPER || this.data.nextMode == BS2GameMode.AVALANCHE_FREESPIN_SUPER;
    }

    public nextSpinMode(): SpinMode {
        if (this.data.nextMode == BS2GameMode.AVALANCHE_NORMAL || this.data.nextMode == BS2GameMode.AVALANCHE_FREESPIN || this.data.nextMode == BS2GameMode.AVALANCHE_FREESPIN_SUPER) {
            return SpinMode.AVALANCHE;
        } else {
            return SpinMode.SPIN;
        }
    }

    public currentSpinMode(): SpinMode {
        if (this.data.mode == BS2GameMode.AVALANCHE_NORMAL || this.data.mode == BS2GameMode.AVALANCHE_FREESPIN || this.data.mode == BS2GameMode.AVALANCHE_FREESPIN_SUPER) {
            return SpinMode.AVALANCHE;
        } else {
            return SpinMode.SPIN;
        }
    }

    private changeXSymToEM(array: string[][]): void {
        array.forEach((reels, reelIdx) => {
            reels.forEach((sym, symIdx) => {
                if (sym === BS2Statics.SYMBOLS.X) {
                    array[reelIdx][symIdx] = BS2Statics.SYMBOLS.EM;
                }
            })
        })
    }

    private changeMidAndHighSym(array: string[][], convertHighToMid: boolean = true): void {
        array.forEach((reels, reelIdx) => {
            reels.forEach((sym, symIdx) => {
                if (convertHighToMid && sym[0] === "H") {
                    array[reelIdx][symIdx] = "M" + sym[1];
                }
            })
        })
    }

    private createXSplitData(data: BS2GameData): void {
        const tempData: XSplitData[] = [];

        for (let reelIdx: number = 0; reelIdx < BS2Statics.NR_OF_REELS; reelIdx++) {
            for (let symIdx: number = 0; symIdx < this.clientReels.matrix[reelIdx].length; symIdx++) {
                if (BS2Statics.SPLIT_SYMBOLS.includes(this.clientReels.matrix[reelIdx][symIdx])) {
                    const scatterCoord: StateMatrixCoordinate[] = this.visibleReelMatrix.getCoordinatesForValueInColumn(reelIdx, BS2Statics.SYMBOLS.S);
                    const scatterPresentInCol: boolean = scatterCoord.length > 0 && symIdx <= scatterCoord[0].row;
                    if (symIdx >= 6 || (!scatterPresentInCol && symIdx === 0)) { // excluding bottom extra symbol
                        continue;
                    }
                    tempData.push({
                        direction: this.clientReels.matrix[reelIdx][symIdx] === BS2Statics.SPLIT_SYMBOLS[0] ? XSplitDirection.HORIZONTAL : XSplitDirection.VERTICAL,
                        splitSymCoordinate: {
                            column: reelIdx,
                            row: symIdx + (scatterPresentInCol ? 0 : -1)
                        },
                        symbolName: this.clientReels.matrix[reelIdx][symIdx]
                    });
                }
            }
        }
        tempData.length > 0 ? this.xSplitData = assignArrayToXSplit() : this.xSplitData = undefined;

        if (this.xSplitData) {
            tempData.forEach((individualSplitData) => {
                switch (individualSplitData.splitSymCoordinate.row) {
                    case 0:
                        this.xSplitData![0].push(individualSplitData);
                        break;
                    case 1:
                        this.xSplitData![1].push(individualSplitData);
                        break;
                    case 2:
                        this.xSplitData![2].push(individualSplitData);
                        break;
                    case 3:
                        this.xSplitData![3].push(individualSplitData);
                        break;
                    case 4:
                        this.xSplitData![4].push(individualSplitData);
                        break
                }
            })
        }

        function assignArrayToXSplit() {
            return [[], [], [], [], []]
        }
    }

    private calculatePossibleWinData2(data: BS2GameData, winData: WinData, visibleReelMatrix: StateMatrix<string>): PossibleWinData {
        const combinedReels: boolean[] = [false, false, false, false, false, false];
        const combinedMatrix: StateMatrix<boolean> = new StateMatrix();
        combinedMatrix.initWithValueAndMatchDimensionsFromMatrix(false, visibleReelMatrix.matrix);

        const currentScatterPositions = ReelUtils.findCurrentVisibleSqueezeSymbolPerReel();


        const lines: PossibleWinLineData[] = [];
        for (let winLine of winData.lines) {
            const lineMatrix = new StateMatrix<boolean>();
            lineMatrix.initWithValueAndMatchDimensionsFromMatrix(false, visibleReelMatrix.matrix);

            const winLineCoords = winLine.matrix.getAllCoordinatesForValue(true);
            lineMatrix.setValueForCoordinates(winLineCoords, true);

            if (BS2.model.isSuperFreespin()) {
                for (let i: number = 0; i < lineMatrix.matrix.length; i++) {
                    const winCoords = lineMatrix.getCoordinatesForValueInColumn(i, true);
                    for (let winCoord of winCoords) {
                        if (winCoord.row == 0 && currentScatterPositions[i] > 0) {
                            //symbol is out side of visible area before squeeze.
                            lineMatrix.setValueForCoordinates([winCoord], false);
                        }
                    }
                }

                let lastValidColumn = 0;
                for (let i: number = 0; i < lineMatrix.matrix.length; i++) {
                    const winCoords = lineMatrix.getCoordinatesForValueInColumn(i, true);
                    if (winCoords.length > 0) {
                        lastValidColumn = i;
                    } else {
                        break;
                    }
                }

                for (let i: number = lastValidColumn + 1; i < lineMatrix.matrix.length; i++) {
                    lineMatrix.setValueForColumn(i, false);
                }
            }


            combinedMatrix.setValueForCoordinates(lineMatrix.getAllCoordinatesForValue(true), true);
            lines.push({
                matrix: lineMatrix,
                reels: lineMatrix.isValueInColumns(true)
            });
        }


        const posCords = combinedMatrix.getAllCoordinatesForValue(true);
        for (let pos of posCords) {
            combinedReels[pos.column] = true;
        }

        return {
            lines: lines,
            combinedMatrix: combinedMatrix,
            combinedReels: combinedReels
        };
    }


}